import './DropdownLayout.scss'

const DropdownLayout = ({ children, className }) => {
    return <div className={`dropdown-layout border border-formOutline ${className}`}>{children}</div>
}

export default DropdownLayout
